<script>
import Multiselect from "@vueform/multiselect";

export default {
  name: "AssignmentSelect",
  components: {
    Multiselect,
  },
  props: {
    modelValue: { type: Array, required: true },
    options: { type: Array, required: true },
    placeholder: { type: String, required: true },
    seatsFor: { type: Function, required: true },
  },
  emits: ["update:modelValue", "input", "edit"],
};
</script>

<template>
  <Multiselect
    :model-value="modelValue"
    mode="tags"
    :placeholder="placeholder"
    :options="options"
    :searchable="true"
    :can-clear="false"
    @input="$emit('input', $event)"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #tag="{ option, handleTagRemove, disabled }">
      <div class="multiselect-tag" :class="{ 'is-disabled': disabled }">
        <span
          role="button"
          title="Edit seats"
          @mousedown.prevent.stop="$emit('edit', option.value)"
        >
          {{ option.value }}: {{ seatsFor(option.value) }}
        </span>
        <span
          v-if="!disabled"
          class="multiselect-tag-remove"
          @click="handleTagRemove(option, $event)"
        >
          <span class="multiselect-tag-remove-icon"></span>
        </span>
      </div>
    </template>
  </Multiselect>
</template>
